/**
 * Given a key/value pair of errors and a key/value pair of touched
 * properties it returns their intersection object (ie it returns
 * only the errors of properties that are touched).
 *
 * @example
 * const errors = { name: 'Name is required', email: 'Email is required' }
 * const touched = { name: true }.
 *
 * getFormikTouchedErrors(errors, touched) // { name: 'Name is required' }
 *
 * @param {Object} errors The Formik errors.
 * @param {Object} touched The Formik touched properties.
 * @returns {{}}
 */
export const getFormikTouchedErrors = (errors = {}, touched = {}) =>
  Object.keys(errors)
    .filter(key => touched[key])
    .reduce((acc, key) => {
      // eslint-disable-next-line no-param-reassign
      acc[key] = errors[key];
      return acc;
    }, {});

/**
 * Clears form fields based on formik handleChange.
 *
 * @param {Function} handleChange Formik handle change method.
 * @param {Array<String>} fieldNames List of fields to set to empty.
 */
export const resetFormikFields = (handleChange, fieldNames = []) => {
  fieldNames.forEach(name =>
    handleChange({
      target: {
        name,
        value: '',
      },
    }),
  );
};
